import { Injectable } from '@angular/core';
import { ResponseType } from '@angular/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { ApiService } from "../../shared/services/api.service";
import { UtilService } from '../../shared/services/util.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class MyBookingsService {
  bulkPaymentPopup = new BehaviorSubject<boolean>(false);
  singlePaymentPopup = new BehaviorSubject<boolean>(false);
  paymentStatus = new BehaviorSubject<any>(null);
  paymentAmount = new BehaviorSubject<any>(null);
  totalAmount = new BehaviorSubject<any>(null);
  pastStartDate = new BehaviorSubject<any>(null);
  pastEndDate = new BehaviorSubject<any>(null);
  openSnackBar = new BehaviorSubject<boolean>(false);
  razorpay_payment_id = new BehaviorSubject<any>("");
  refreshBookings = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiService,  private utilService: UtilService, private http: HttpClient,
    ) { }

  public convertToMB(filesize){
    return (filesize / (1024 * 1024)).toFixed(4);
  }

  public downloadDocument(filename, bookingId){

    this.downloadDoc(bookingId, filename).subscribe(res => {
      const file = new File([res], filename, { type: 'multipart/form-data' });
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', file.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // free memory space
     });
  }

  public fetchBookingHistory(searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'fetchBookingHistory',
      type: 'GET',
      queryParams: searchQuery
    });
  }

  public fetchPaymentCart(queryString: any, body: any)  {
    return this.apiService.httpRequest({
      url: 'fetchPaymentCart',
      type: 'POST',
      body,
      queryParams: queryString,
    });
  }

  public verifyPayment( body: any){
    return this.apiService.httpRequestAsText({
      url: 'verifyPayment',
      type: 'POST',
      body
    });
  }

  public fetchDocuments(bookingId){
    return this.apiService.httpRequest({
      url: 'fetchDocuments',
      type: 'GET',
      queryParams: {bookingId}
    });
  }

  public downloadDoc(bookingId, filename){
    const url = `${environment.apiBaseUrl}spot/downloadDoc`;
    const params = new HttpParams()
    .set('bookingId', bookingId)
    .set('fileName', filename);

    return this.http.get(url, { responseType: 'blob', params });
  }

  public deleteDoc(bookingId, filename){
    const url = `${environment.apiBaseUrl}spot/deleteFile`;
    const params = new HttpParams()
    .set('bookingId', bookingId)
    .set('fileName', filename);

    return this.http.delete(url, { responseType: 'text', params });
  }

  getDateObjFromStringToDisplay(dateString: string){
    return new Date(parseInt(dateString.split(' ')[0].split('/')[2]), (parseInt(dateString.split(' ')[0].split('/')[1]) - 1), parseInt(dateString.split(' ')[0].split('/')[0]), parseInt(dateString.split(' ')[1].split('/')[0]), parseInt(dateString.split(' ')[1].split('/')[1]),  0);
}

getDatePart(date: string, type: string){
  const dateObj = this.getDateObjFromStringToDisplay(date);
  switch (type){
    case 'date':
        if (dateObj) {
          return dateObj.getDate();
        }
        break;
    case 'day':
        if (dateObj && dateObj.toString().split(' ')[0]) {
          return dateObj.toString().split(' ')[0].toUpperCase();
        }
        break;
    case 'month':
        if (dateObj && dateObj.toString().split(' ')[1]) {
          return dateObj.toString().split(' ')[1].toUpperCase();
        }
        break;
    case 'time':
        if (dateObj){
          const hours = '0' + dateObj.getHours(), minutes = '0' + dateObj.getMinutes();
          return hours.substring(hours.length - 2, hours.length) + ':' + minutes.substring(minutes.length - 2, minutes.length);
        }
        break;
  }
}
getStopsCompleteView(booking, timeformat){
  const completeView = [];
  booking?.stops?.forEach(stop => {
    const dateMoment = this.utilService.getMoment(stop.time);
    completeView.push({
      time: ( stop.time ? timeformat === 'false'
      ? this.getDatePart(stop.time, 'time') : dateMoment.format('hh:mm A') : ''),
      address: stop.address,
      pointType: stop.pointType,
      riders: stop.riders,
      geoArea: stop.geoArea
    });
  });
  return completeView;
}

  verifyEngagementCode(data: any){
    return this.apiService.httpRequestAsText({
      url: 'verifyEngagementCode',
      type: 'POST',
      body: data 
    });
  }
}
